<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Consultar de Pagos Proveedor
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Cuenta Corriente Proveedor</span>
      <span> /</span>
      <span>Consultar de Pago</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form [formGroup]='formHeader' novalidate>
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fecha_desde"></mdb-date-picker>
          </div>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechahasta" [placeholder]="'Hasta'" required
              formControlName="fecha_hasta"></mdb-date-picker>
          </div>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="text" id="rutproveedor" class="form-control" placeholder="9.999.999-9" required
              #rutcliente formControlName="rutProveedor" formatRut />
            <label for="rutcliente">RUT Proveedor</label>
          </div>
        </div>
        <div class="col d-flex" style="max-width: 300px;">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarProveedor()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;">
            {{ proveedorSeleccionado?.nombre }}
          </h6>
        </div>
        <div class="col" style="max-width: 150px">
          <div class="md-form">
            <input value="" type="text" id="nroPago" formControlName="codigo" class="form-control" placeholder="9999"
              required #nroPago />
            <label for="nroPago">Nro. Pago</label>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente" *ngIf="listaMovimientos">
  <div class="card-body justify-content-between">
    <!-- <div class="row filtros-body">
      <div class="col">
        <h5>Listado de pagos</h5>
      </div>
    </div> -->
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Fecha</th>
            <th scope="col">Nro. Pago</th>
            <th scope="col">RUT</th>
            <th scope="col">Proveedor</th>
            <th scope="col" class="text-right">Monto</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && listaMovimientos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let mov of listaMovimientos">
            <td>{{mov.fecha_pago | fecha}}</td>
            <td>{{mov.codigo | numerico}}</td>
            <td>{{mov.rutFormato | rut}}</td>
            <td>{{mov.cliente_proveedor_nombre}}</td>
            <td align="right">$ {{mov.monto | numerico}}</td>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                (click)="loadAndShowPago(mov)" mdbTooltip="Ver" placement="right">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn">
      Excel
    </button>
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn">
      PDF
    </button>
  </div>
</div>

<!-- MODAL verPago-->
<div mdbModal #verPago="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 80%" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Detalle pago
        </h4>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="verPago.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row filtros-body">
          <div class="col">
            <h5>Documento pendiente por pagar</h5>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">Nro. Doc</th>
                <th scope="col">Emisión</th>
                <th scope="col">Vencimiento</th>
                <th scope="col" class="text-right">Monto</th>
                <th scope="col" class="text-right">Acumulado</th>
                <th scope="col" class="text-right">Pago</th>
                <th scope="col" class="text-right">Deuda</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>12312</td>
                <td>03/01/2020</td>
                <td>03/02/2020</td>
                <td align="right">700</td>
                <td align="right">0</td>
                <td align="right">420</td>
                <td align="right">280</td>
              </tr>
              <tr>
                <td>5345</td>
                <td>03/01/2020</td>
                <td>03/02/2020</td>
                <td align="right">800</td>
                <td align="right">50</td>
                <td align="right"></td>
                <td align="right">750</td>
              </tr>
            </tbody>
            <tbody class="blue lighten-5">
              <tr>
                <td align="right" colspan="3"><strong>Totales</strong></td>
                <td align="right"><strong>1500</strong></td>
                <td align="right"><strong>50</strong></td>
                <td align="right"><strong>420</strong></td>
                <td align="right"><strong>1030</strong></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row filtros-body">
          <div class="col">
            <h5>Nota de Crédito</h5>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">Nro. Doc.</th>
                <th scope="col">Emisión</th>
                <th scope="col">Vencimiento</th>
                <th scope="col" class="text-right">Monto</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>5632</td>
                <td>03/01/2020</td>
                <td>03/01/2020</td>
                <td align="right">25</td>
              </tr>
              <tr>
                <td>1233</td>
                <td>03/01/2020</td>
                <td>03/01/2020</td>
                <td align="right">35</td>
              </tr>
            </tbody>
            <tbody class="blue lighten-5">
              <tr>
                <td align="right" colspan="3">
                  <strong>Total en Nota de Crédito usadas</strong>
                </td>
                <td align="right"><strong>200</strong></td>
              </tr>
              <tr>
                <td align="right" colspan="3">
                  <strong>Diferencia a pagar</strong>
                </td>
                <td align="right"><strong>320</strong></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row filtros-body">
          <div class="col">
            <h5>Formas de pago</h5>
          </div>
        </div>
        <div class="table-responsive mt-1">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">Tipo abono</th>
                <th scope="col">Nro. Cheque</th>
                <th scope="col" class="text-right">Monto</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Canje</td>
                <td>Factura Nro. 1231233</td>
                <td align="right">120</td>
              </tr>
              <tr>
                <td>Canje</td>
                <td>Transferencia Nro. 34563456456</td>
                <td align="right">100</td>
              </tr>

              <tr>
                <td>Canje</td>
                <td>Cheque Nro. 478</td>
                <td align="right">100</td>
              </tr>
            </tbody>
            <tbody class="blue lighten-5">
              <tr>
                <td align="right" colspan="2">
                  <strong>Total forma de pago</strong>
                </td>
                <td align="right"><strong>320</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="verPago.hide()"
          mdbWavesEffect>
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarProveedor -->
<div mdbModal #seleccionarProveedor="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar proveedor
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="seleccionarProveedor.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="rutVend" class="form-control" placeholder="Nombre o RUT del proveedor"
                required #rutVend />
              <label for="rutVend">Nombre o RUT del proveedor</label>
            </div>
          </div>
          <div class="col" style="width: 50px">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="seleccionarProveedor.show()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
          </div>
        </div>
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" class="text-center">RUT</th>
              <th scope="col" class="text-center">Nombre</th>
              <th scope="col" class="text-center">Sucursal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre proveedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarProveedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre proveedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarProveedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre proveedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarProveedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarProveedor -->
<app-modal-seleccionar-proveedor [multiple]="false" (onSelect)="onProveedorSeleccionado($event)" queryType="ONLY_RUT"
  showInfoProveedorInactivoBloqueado="true" (onNotFound)="onProveedorNoEncontrado()">
</app-modal-seleccionar-proveedor>

<!-- MODAL verPago-->
<app-consultar-pagos-proveedor-modal-view-details></app-consultar-pagos-proveedor-modal-view-details>